import React from "react";
import {  Tabs, message, Modal } from "antd";
import MiCompAPI from "../../../util/api";
import TableWrapper from "../../elements/TableWrapper";
import StateSpecificQuestion from "./StateSpecificQuestion";
import BackgroundQuestion from "./BackgroundQuestion";
const { TabPane } = Tabs;
const { confirm } = Modal;
class Questions extends React.Component {


  constructor(props) {

    super(props);
    this.api = new MiCompAPI(this.props.userPermandMasters);

    this.tableButtons = [];
    this.tableButtons.push({
      buttonType: "primary",
      content: "Add",
      clickHandler: () => {
        this.addQuestionDefaultHandler();
      },


    })
    this.tableStateButtons = [];
    this.tableStateButtons.push({
      buttonType: "primary",
      content: "Add",
      clickHandler: () => {
        this.addStateQuestionDefaultHandler();
      },


    })

    this.state =
    {
      isLoading: this.props.isLoading,
      defaultActiveKey: "1",
      questions: [],
      bgQuestions: [],
      question: null,
      bgQuestion: null,
      addQuestionActive: false,
      addStateQuestionActive: false,
      QuestionEditable: false,
      states: []
    };


    this.BackgroundQuestions = [
      {
        title: 'Eligibilit Type',
        dataIndex: 'eligibilityType',
        sorter: (a, b) => a.license_class.localeCompare(b.license_class),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Type',
        dataIndex: 'type',
        sorter: (a, b) => a.license_no.localeCompare(b.license_no),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Question',
        dataIndex: 'question',
        sorter: (a, b) => a.license_class.localeCompare(b.license_class),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Question Description',
        dataIndex: 'question_Description',
        sorter: (a, b) => a.license_no.localeCompare(b.license_no),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Actions',
        width: '20%',
        render: (text, record) => {
          return (
            <div style={{ display: 'flex' }}>
              <>
                <i className="fa fa-pencil fa-b" onClick={() => { this.EditBackgroundQuestions( record["id"]) }} />
                <i onClick={() => this.showConfirmBackgroundQuestions( record["id"])} className="fa fa-trash fa-red " />

              </>
            </div>
          );
        }
      }

    ];
    this.StateSpecificQuestions = [
      {
        title: 'State',
        dataIndex: 'state_Name',
        sorter: (a, b) => a.state_Name.localeCompare(b.state_Name),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Question',
        dataIndex: 'question',
        sorter: (a, b) => a.question.localeCompare(b.question),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Question Description',
        dataIndex: 'question_Description',
        sorter: (a, b) => a.question_description.localeCompare(b.question_description),
        sortDirections: ["descend", "ascend"]
      }, {
        title: 'Actions',
        width: '20%',
        render: (text, record) => {
          return (
            <div style={{ display: 'flex' }}>
              <>
                <i className="fa fa-pencil fa-b" onClick={() => { this.EditStateSpecificQuestions(record["id"]) }} />
                <i onClick={() => this.showConfirmStateSpecificQuestions( record["id"])} className="fa fa-trash fa-red " />

              </>
            </div>
          );
        }
      }

    ]
  }
  showConfirmStateSpecificQuestions = ( id) => {
    confirm({
      title: "Do you want to delete this Question?",
      onOk: () => {
        this.api.invoke("DeleteStateSpecificQuestion/" + id, "patch", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
              this.setState({ isLoading: false });

              this.GetAllStateSpecificQuestions()

            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }

          }

        });
      },
      okText: "yes",
      cancelText: "No",
      onCancel() { },

    });
  }
  showConfirmBackgroundQuestions = ( id) => {
    confirm({
      title: "Do you want to delete this Question?",
      onOk: () => {
        this.api.invoke("DeleteBackGroundQuestion/" + id, "patch", (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
              this.setState({ isLoading: false });

              this.GetAllBackGroundQuestions();

            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }

          }

        })
      },
      okText: "yes",
      cancelText: "No",
      onCancel() { },

    });
  }
  handleEditStatus = () => {

    this.setState({ QuestionEditable: !this.state.QuestionEditable })
  };

  addQuestionDefaultHandler = () => {
    this.setState({ addQuestionActive: !this.state.addQuestionActive });
  };
  addStateQuestionDefaultHandler = () => {
    this.setState({ addStateQuestionActive: !this.state.addStateQuestionActive });
  };
  EditStateSpecificQuestions = (id) => {
    this.api.invoke(
      "GetStateSpecificQuestionById/" + id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              question: data.data,
              addStateQuestionActive:true
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      });
  }
  EditBackgroundQuestions = (id) => {
    this.api.invoke(
      "GetBackGroundQuestionById/" + id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              bgQuestion: data.data,addQuestionActive:true
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      });
  }
  GetAllStateSpecificQuestions=()=>{
    this.api.invoke(
      "GetAllStateSpecificQuestions",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              isLoading: false,
              questions: data.data
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      });
  }
  GetAllBackGroundQuestions=()=>{
    this.api.invoke(
      "GetAllBackGroundQuestions",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              isLoading: false,
              bgQuestions: data.data
            })
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      });
  }
  componentDidMount = () => {
  this.GetAllBackGroundQuestions();
  this.GetAllStateSpecificQuestions()

    this.getClientMasters();
  };
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            states: data.states,
          });
        }
      },
      ["STATE"]
    );
  }

  addQuestionsSubmitHandler = (values, callback) => {

    message.loading("Adding BackGround Questions..", 0);
    this.api.invoke(
      "SaveandUpdateBackGroundQuetion",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addQuestionActive: false });
            this.GetAllBackGroundQuestions();

            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
          message.destroy();
          message.error("Add address failed. Contact Support", 3);
          callback(false);
        }
      },
      values
    );
  };

  addStateQuestionsSubmitHandler = (values, callback) => {

    message.loading("Adding Spesific State Questions..", 0);
    this.api.invoke(
      "SaveandUpdateStateSpecificQuestion",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addStateQuestionActive: false });
            this.GetAllStateSpecificQuestions()

            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
          message.destroy();
          message.error("Add address failed. Contact Support", 3);
          callback(false);
        }
      },
      values
    );
  };


  render() {
    return (
      <div className="mi_main_div" >
        {this.state.addQuestionActive ? (
          <Modal
            visible={this.state.addQuestionActive}
          >
            <BackgroundQuestion
              closeDrawerHandler={this.addQuestionDefaultHandler}
              submitHandler={this.addQuestionsSubmitHandler}
              width={500}
              bgQuestion={this.state.bgQuestion}
              userPermandMasters={this.props.userPermandMasters}
              title="BackGround Questions"
            />
          </Modal>
        ) : null}
        {this.state.addStateQuestionActive ? (
          <Modal
            visible={this.state.addStateQuestionActive}
          >
            <StateSpecificQuestion
              closeDrawerHandler={this.addStateQuestionDefaultHandler}
              submitHandler={this.addStateQuestionsSubmitHandler}
              width={500}
              states={this.state.states}
              question={this.state.question}
              userPermandMasters={this.props.userPermandMasters}
              title="State Specific Questions"
            />
          </Modal>
        ) : null}
        <Tabs style={{ padding: '0px 10px' }} defaultActiveKey={this.state.defaultActiveKey}>

          <TabPane tab={<span >BackGround Questions</span>} key="1" >
            <div  >


              <TableWrapper rowKey="id"
                columns={this.BackgroundQuestions}
                data={this.state.bgQuestions&&this.state.bgQuestions}
                loading={this.state.isLoading}
                buttons={this.tableButtons}

              />

            </div>
          </TabPane>

          <TabPane tab={<span>State Specific Questions</span>} key="2">
            <div >
              <TableWrapper rowKey="id"
                columns={this.StateSpecificQuestions}
                data={this.state.questions&&this.state.questions}
                loading={this.state.isLoading}
                buttons={this.tableStateButtons}


              />
            </div>
          </TabPane>
        </Tabs>



      </div>

    );
  }
}
export default Questions;
